import type { FC } from "react";
import { useState } from "react";

import HealthUpdateModal from "@/components/modals/profil-health/health-update-modal";
import GeneralHealthDropButton from "@/components/patient/general-health-drop-button";
import type { PatientProps } from "@/components/patient/patient-profile";
import PatientProfilePart from "@/components/patient/patient-profile-part";

const PatientGeneralHealth: FC<PatientProps> = ({ patient }) => {
  const [healthModalOpen, setHealthModalOpen] = useState<
    "pathology" | "allergy" | "womenHealth" | "none"
  >("none");

  return (
    <PatientProfilePart title={"Santé générale"}>
      <GeneralHealthDropButton
        mode={"pathology"}
        values={patient.associatedPathologies}
        comment={patient.pathologyComment}
        setHealthModalOpen={setHealthModalOpen}
      />
      <GeneralHealthDropButton
        mode={"womenHealth"}
        values={patient.womenHealth}
        comment={patient.womenHealthComment}
        setHealthModalOpen={setHealthModalOpen}
      />
      <GeneralHealthDropButton
        mode={"allergy"}
        values={patient.allergies}
        comment={patient.allergiesComment}
        setHealthModalOpen={setHealthModalOpen}
      />
      <HealthUpdateModal
        healthModalOpen={healthModalOpen}
        setHealthModalOpen={setHealthModalOpen}
        patient={patient}
      />
    </PatientProfilePart>
  );
};

export default PatientGeneralHealth;
